import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '@/services/api'
import { Settings } from '@/types'

function Footer() {
  const [settings, setSettings] = useState<Settings | null>(null)

  useEffect(() => {
    api.get<Settings>('/settings')
      .then(setSettings)
      .catch(err => console.error('Failed to load settings:', err))
  }, [])

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{settings?.candidate_name || 'Avenir Théopolitain'}</h3>
            <p>{settings?.slogan || 'Pour une ville moderne et solidaire'}</p>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email : {settings?.contact_email || 'contact@avenirtheropolitain2026.fr'}</p>
          </div>

          {settings && (settings.social_facebook || settings.social_twitter || settings.social_instagram || settings.social_linkedin) && (
            <div className="footer-section">
              <h4>Réseaux sociaux</h4>
              <div className="social-links">
                {settings.social_facebook && (
                  <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer">
                    Facebook
                  </a>
                )}
                {settings.social_twitter && (
                  <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer">
                    Twitter
                  </a>
                )}
                {settings.social_instagram && (
                  <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer">
                    Instagram
                  </a>
                )}
                {settings.social_linkedin && (
                  <a href={settings.social_linkedin} target="_blank" rel="noopener noreferrer">
                    LinkedIn
                  </a>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="footer-bottom">
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '0.5rem' }}>
            <Link to="/mentions-legales" style={{ color: 'white', textDecoration: 'none' }}>
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" style={{ color: 'white', textDecoration: 'none' }}>
              Politique de confidentialité
            </Link>
          </div>
          <a href="https://del-com.pro/" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>&copy; {new Date().getFullYear()} Del-com</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
